import { Component, Input } from '@angular/core';
import { AuditEntry, ImpactAnalysis, PermissionDiff, RoleDetailResponse } from '../../roles.model';

export type SidebarMode =
  | 'view'
  | 'edit-idle'
  | 'edit-changes'
  | 'save-success';

@Component({
  selector: 'app-role-sidebar',
  standalone: false,
  templateUrl: './role-sidebar.component.html',
  styleUrls: ['./role-sidebar.component.scss'],
})
export class RoleSidebarComponent {
  @Input() mode: SidebarMode = 'view';
  @Input() role: RoleDetailResponse | null = null;
  @Input() diff: PermissionDiff = { added: [], removed: [] };
  @Input() impact: ImpactAnalysis = { affectedUsers: 0, gainAccess: 0, loseAccess: 0 };
  @Input() auditEntries: AuditEntry[] = [];
  @Input() moduleCountsMap: { [name: string]: { granted: number; total: number } } = {};

  readonly MODULE_NAMES = [
    'User Management',
    'Roles & Permissions',
    'Geographic Nodes',
    'Channels',
    'POS',
    'SKU Management',
    'Dispatch & Operations',
    'Reports & Analytics',
    'System Settings',
  ];

  get totalPermissions(): number {
    return Object.values(this.moduleCountsMap).reduce((sum, m) => sum + m.total, 0);
  }

  get displayCode(): string {
    if (!this.role) return '';
    return 'ROLE-' + this.role.id.substring(0, 5).toUpperCase();
  }

  get hasChanges(): boolean {
    return this.diff.added.length > 0 || this.diff.removed.length > 0;
  }

  formatPermCode(code: string): string {
    return code.replace('.', ' › ');
  }
}
